<div class="flex-col">
  <p>Recherchez votre clinique dans la liste. Si vous ne la trouvez pas, choississez "Créer une nouvelle clinique" dans la liste pour ajouter votre clinique.</p>
  <form [formGroup]="clinicFormGroup">
    <ng-container *ngIf="!addNewClinic">
      <input type="hidden" formControlName="name">
      <input type="hidden" formControlName="zipCode">
      <app-clinic-search (clinicSelected)="onClinicSelected($event)"></app-clinic-search>
    </ng-container>
    <ng-container *ngIf="addNewClinic">
      <div class="flex-row">
        <mat-form-field class="zip-code" appearance="outline">
          <mat-label>{{'clinics.popup.postal_code' | translate}}</mat-label>
          <input formControlName="zipCode" matInput required>
          <mat-error *ngIf="clinicFormGroup.get('zipCode')?.hasError('required')">
            {{'clinics.popup.err_postal_code_required' | translate}}</mat-error>
          <mat-error
            *ngIf="!clinicFormGroup.get('zipCode')?.hasError('required') && clinicFormGroup.get('zipCode')?.hasError('pattern')">
            {{'clinics.popup.err_postal_code_pattern' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{'clinics.popup.name' | translate}}</mat-label>
          <input formControlName="name" matInput required>
          <mat-error *ngIf="clinicFormGroup.get('name')?.hasError('required')">{{'clinics.popup.err_name_required' |
            translate}}</mat-error>
          <mat-hint *ngIf="clinicLabelAlreadyExistWarning" class="warning">
            {{ 'clinics.popup.similarity_warning' | translate: { clinic: clinicList[0].name, city: clinicList[0].city ?? '', phone: clinicList[0].phone === null ? '' : '(' + clinicList[0].phone +')' } }}
          </mat-hint>
          <mat-hint *ngIf="clinicLabelAlreadyExistConfirm" class="error">
            {{ 'clinics.popup.similarity_error' | translate: { clinic: clinicList[0].name, city: clinicList[0].city ?? '', phone: clinicList[0].phone === null ? '' : '(' + clinicList[0].phone +')' } }}
          </mat-hint>
          <mat-error *ngIf="clinicFormGroup.get('name')?.hasError('alreadyExist')">{{ 'clinics.popup.already_exist_error'
            | translate }}</mat-error>
        </mat-form-field>
      </div>
      <div class="flex-row">
        <mat-form-field appearance="outline" class="typeClinic">
          <mat-label>{{'clinics.popup.clinic_type' | translate}}</mat-label>
          <mat-select formControlName="clinicType" required>
            <mat-option *ngFor="let clinicType of clinicTypes$| async" [value]="clinicType.id">{{clinicType.label}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="clinicFormGroup.get('clinicType')?.hasError('required')">
            {{'clinics.popup.err_clinic_type_required' | translate}}</mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>{{'clinics.popup.email' | translate}}</mat-label>
          <input formControlName="email" matInput type="email">
          <mat-error *ngIf="clinicFormGroup.get('email')?.hasError('email')">
            {{ 'clinics.popup.err_email_invalid' | translate }}
          </mat-error>
          <mat-error *ngIf="clinicFormGroup.get('email')?.hasError('required')">
            {{ 'clinics.popup.err_email_invalid' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <div class="flex-row">
        <mat-form-field appearance="outline">
          <mat-label>{{'clinics.popup.address1' | translate}}</mat-label>
          <input formControlName="address1" matInput>
        </mat-form-field>
      </div>
      <div class="flex-row">
        <mat-form-field appearance="outline">
          <mat-label>{{'clinics.popup.address2' | translate}}</mat-label>
          <input formControlName="address2" matInput>
        </mat-form-field>
      </div>
      <div class="flex-row">
        <mat-form-field appearance="outline">
          <mat-label>{{'clinics.popup.city' | translate}}</mat-label>
          <input formControlName="city" matInput>
        </mat-form-field>

        <mat-form-field appearance="outline" class="phone">
          <mat-label>{{'clinics.popup.phone' | translate}}</mat-label>
          <input formControlName="phone" matInput>
        </mat-form-field>
      </div>
    </ng-container>
  </form>
</div>
